import { render, staticRenderFns } from "./TransactionDetailEventsSection.vue?vue&type=template&id=1798d9c2"
import script from "./TransactionDetailEventsSection.vue?vue&type=script&lang=js"
export * from "./TransactionDetailEventsSection.vue?vue&type=script&lang=js"
import style0 from "./TransactionDetailEventsSection.vue?vue&type=style&index=0&id=1798d9c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports